import md5 from 'md5';

const baasicTranslateOverride = msg => {
	// Fallthrough if backend has returned translation key
	if (msg.toUpperCase(msg) === msg) return msg;
	// Hashed key for translation
	return 'BAASIC.' + md5(msg);
};

export { baasicTranslateOverride };
